import React, { useState } from 'react';
import axios from 'axios';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        yourWebsite: '',
        yourMessage: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://yautiktechnology.com/api/contactform', formData);
            alert('Thank you for contacting with us, Team will get back to you soon !');
            setFormData({ name: '', email: '', phoneNumber: '', yourWebsite: '', yourMessage: '' });
        } catch (error) {
            alert('Error sending message. Please try again.');
        }
    };

    return (
        <form id="contact-form" onSubmit={handleSubmit}>
            <div className="row">   
                <div className="col-md-6 mb-30">
                    <input
                       className="from-control"
                       type="text"
                       id="name"
                       name="name"
                       placeholder="Name"
                       value={formData.name}
                       onChange={handleChange}
                       required
                    />
                </div>     
                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="text"
                        id="email"
                        name="email"
                        placeholder="E-Mail"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="text"
                        id="phoneNumber"
                        name="phoneNumber"
                        placeholder="Phone Number"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-6 mb-30">
                    <input
                        className="from-control"
                        type="text"
                        id="yourWebsite"
                        name="yourWebsite"
                        placeholder="Your Website"
                        value={formData.yourWebsite}
                        onChange={handleChange}
                        
                    />
                </div>
                <div className="col-12 mb-30">
                    <textarea
                        className="from-control"
                        id="yourMessage"
                        name="yourMessage"
                        placeholder="Your message Here"
                        value={formData.yourMessage}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            <div className="btn-part">
                    <button
                    className='readon learn-more submit'
                     type="submit">Send Message</button>
             </div>  
    </form>
           
        );
    };

    export default ContactForm;
